export function templateOpenFromTo( lang: string, from: string, to: string ): string {
	if ( 'en' === lang ) {
		return `Open from ${from} to ${to}`;
	}

	return `Open van ${from} tot ${to}`;
}
